// Czech category labels.
export const HELP_CATEGORIES = [
  { id: 'getting-started', label: 'Začínáme', icon: '🚀' },
  { id: 'data', label: 'Příprava a nahrávání dat', icon: '📁' },
  { id: 'analysis', label: 'Spuštění analýzy', icon: '▶️' },
  { id: 'results', label: 'Porozumění výsledkům', icon: '📊' },
  { id: 'troubleshooting', label: 'Řešení problémů', icon: '🛠️' },
]
